module.exports = __webpack_public_path__ + "img/file-earmark-text.2b64ed36.svg";